import React from "react";
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const SocialItem = ({ icon, link }) => {
  return (
    <div className="row-span-1 my-4 flex items-center">
      <a href={link}>{icon}</a>
    </div>
  );
};

export default function Footer() {
  const navItems = [
    {
      link: "#about",
      label: "About Me",
    },
    {
      link: "#skills-certifications",
      label: "Skills & Certifications",
    },
    {
      link: "#projects",
      label: "Projects",
    },
  ];

  const handleNavClick = (e, link) => {
    e.preventDefault();
    const targetElement = document.querySelector(link);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="bg-gray-900 px-10 md:px-20 py-2 md:py-4 grid grid-cols-2 md:grid-cols-3 gap-10">
      <div className="col-span-1 content-center">
        <h2 className="text-base md:text-xl font-semibold">Quick Links </h2>
        <div className="flex justify-start space-x-2 md:space-x-6 my-1 md:my-2 text-xs md:text-base">
          {navItems.map((item, index) => (
            <a
              href={item.link}
              className="text-white  hover:text-secondary transition duration-500 delay-100"
              onClick={(e) => handleNavClick(e, item.link)}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
      <div className="col-span-1 md:col-span-2 text-end content-center">
        <h2 className="text-base md:text-xl font-semibold">Follow Me On </h2>
        <div className="flex justify-end space-x-2 md:space-x-6">
          <SocialItem
            icon={
              <FaXTwitter className="text-lg md:text-2xl text-white hover:text-secondary transition duration-500 delay-100" />
            }
            link="https://x.com/JatinBisht71876"
          />

          <SocialItem
            icon={
              <FaInstagram className="text-lg md:text-2xl text-white hover:text-secondary transition duration-500 delay-100" />
            }
            link="https://instagram.com"
          />
          <SocialItem
            icon={
              <FaLinkedin className="text-lg md:text-2xl text-white hover:text-secondary transition duration-500 delay-100" />
            }
            link="https://www.linkedin.com/in/jatin-bisht-861b3b227/"
          />
        </div>
      </div>
    </div>
  );
}
